var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('activity-form',{attrs:{"simplified":true},on:{"saved":_vm.saveActivity,"cancelEdit":_vm.cancelCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }